<template>
  <div class="search-result">
    <div class="search-info">
      您当前的搜索关键词是为"<span class="keyword">{{cardCategory.name}}</span>"。锦汇卡回收为您找到以下相关结果：
    </div>

    <!-- 商超卡分类 -->
    <div class="card-category">
      <div class="card-list">
        <div class="card-item" @click.stop="seacrchClick(item)"  v-for="item in list" :key="item.id">
          <div class="card-logo">
            <img :src="imageBaseUrl + item.pcImg"" alt="" />
          </div>
          <div class="card-name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
export default {
  name: 'SearchResult',
  data() {
    return {
      searchKeyword: this.$route.query.search || '',
      cardCategory: undefined,
      imageBaseUrl: '',
      list: []
    }
  },
  mounted() {
    this.getCardCategory();
  },
  methods: {

    seacrchClick(vl){
      this.$store.commit("changedProdId", vl.prodTypeId);
      this.$store.commit("changedProductId", vl.id);
      this.$router.push("Sales")
      this.$bus.$emit("changedTab", 1);

    },

    // 获取商超卡分类
  getCardCategory() {
  http.get("/product/product/list?prodName=" + this.searchKeyword).then((response) => {
    if (response.code === 200) {
      if (response.data.length > 0) {
        let cardCategoryList = localStorage.getItem('cardCategoryList');
        if (cardCategoryList) {
          cardCategoryList = JSON.parse(cardCategoryList);
        } else {
          cardCategoryList = [];
        }
        // 过滤掉重复的数据
        const newCard = response.data[0];
        this.list = response.data;
        cardCategoryList = cardCategoryList.filter(card => card.id !== newCard.id);
        cardCategoryList.push(newCard);
        if (cardCategoryList.length > 5) {
          cardCategoryList.shift();
        }
        localStorage.setItem('cardCategoryList', JSON.stringify(cardCategoryList));
        this.cardCategory = newCard;
        this.$bus.$emit('updateCardCategory', newCard);
      }
    }
  });
}
}
}
</script>

<style lang="less" scoped>
.search-result {
  background-color: #f4f6fc;
  padding: 20px 120px;

  .search-info {
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;

    .keyword {
      color: #488eff;
    }
  }

  .card-category {
    h2 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .card-list {
      background: #fff;
      padding: 20px;
      border-radius: 8px;

      .card-item {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        padding: 15px 25px;
        background: #f5f6fc;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        z-index: 100;
        margin-right: 5px;
        margin-bottom: 5px;
        height: 80px;
        width: 200px;
        overflow:hidden;
        padding: 0px 10px;
        box-sizing: border-box;



        &:hover {
          border: 1px solid #488eff;
        }

        .card-logo {
          width: 40px;
          height: 40px;
          margin: 8px 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            flex-shrink: 0;
          }
        }

        .card-name {
          white-space:nowrap;
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>
